import { FormattedMessage } from 'react-intl';

export default function RefundNotice() {
  return (
    <p className="rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-800">
      <FormattedMessage id="schedule.refundNotice" />
    </p>
  );
}
